import { Fragment } from "react";
import Link from "next/link";
import classes from "./ProfileTab.module.scss";
import clsx from "clsx";

interface ProfileTabProps {
  active: boolean;
  link: string;
  title: string;
  subTitle: string;
}

export default function ProfileTab(props: ProfileTabProps) {
  const { active } = props;
  const Wrapper = active ? Fragment : Link;
  const wrapperProps: { href?: string } = {};
  if (!active) wrapperProps.href = props.link;
  return (
    <Wrapper {...wrapperProps}>
      <div
        className={clsx(classes["tab"], {
          [classes["active"]]: active,
        })}
        role={!active ? "button" : "tab"}
      >
        <div className={classes["title"]}>{props.title}</div>
        <div className={classes["sub-title"]}>{props.subTitle}</div>
      </div>
    </Wrapper>
  );
}
